const $ = require('jquery');
$.noConflict();
$.DataTable = require('datatables.net');
import WithSystem from './../service/WithSystem';
export default class LeanerAssingmentTbl extends React.Component{
  constructor(props){
    super(props); 
    this.tablerender = null;
  }
  componentDidMount() {
    this.leanerAssingmentreportrender();
  }
  leanerAssingmentreportrender = () => {
    this.tablerender = $(this.refs.main1).DataTable({
      "lengthMenu": [window.showlimit],
      "lengthChange": false,
      "bFilter": false,
      "stateSave": false,
      "scrollX": true,
      "ordering": true,
      autoWidth: false,
      "columnDefs": [
       { className: "center-align", targets: [2,7] },
        // {
        //   "targets": [2],
        //   "createdCell": function (td, cellData, rowData, row, col) {
        //     console.log(td,cellData,rowData,row,col);
        //     if ( cellData == '-' ) {
        //       $(td).css('text-align', 'center !important');
        //     }
        //   }
        // },
      ],
      "order": [[0, "asc"]],
      "processing": true,
      "serverSide": true,
        ajax: {
          type: "POST",
          data: { 'learnerid': this.props.learnerid, 'learnerCourseid': this.props.learnerCourseid},
          beforeSend: function () {
            $("#progress-filter-loading").addClass("show");
          },
          url: admin_url + 'Consolidate_reports/learners_assignment_report'+__setSsAuthUrl,
          "dataSrc": function (response) {
            $("#progress-filter-loading").removeClass("show");
            return response.aaData;
          },
        },
     
        'columns': [
    { "mRender": function ( data, type, row ) {
      return `${row.dtua_course_name}`;
        }
    }, 
    { "mRender": function ( data, type, row ) {
      if (row.dtua_evaluated == 1 && row.dtua_status == 2) {
        return `<span class="leaner-grade grade-success">Graded</span>`;
      }else{
        return `<span class="leaner-grade grade-no-success">Not Graded</span>`;
      }
        }
    }, 
    { "mRender": function ( data, type, row ) {
      // var timeRemainingList = '<span class="center-align">-</span>';
      var timeRemainingList = '-';
      if (row.dtua_last_date != null){
      if (row.dtua_status == 1 || row.dtua_status == 2) {
        timeRemainingList = time_remaining(row.dtua_status, convertUTCtoLocalTime(row.dt_submission_datetime), convertUTCtoLocalTime(row.created_date));
      } else {
        timeRemainingList = time_remaining(row.dtua_status, convertUTCtoLocalTime(row.dt_submission_datetime));
      }
      }
      return `${timeRemainingList}`;
        }
    },
    { "mRender": function ( data, type, row ) {
      var formateed_date = formatAMPM(changeDatesFormat(convertUTCtoLocalTime(row.created_date)));
      return `${formateed_date}`;
        }
    },
    { "mRender": function ( data, type, row ) {
      let feedbackText = "";
      if (row.dtua_feedbacks != null && row.dtua_feedbacks != ''){
      var feedBacks  = JSON.parse(row.dtua_feedbacks);
      feedBacks.forEach(allFeedbacks);
      function allFeedbacks(feed) {
        feedbackText += feed['comment'] != undefined ? feed['comment'] : '';
        feedbackText += "<br>";
      }
      }
      return `${feedbackText}`;
        }
    },
    { "mRender": function ( data, type, row ) {
      let commentCount = 0;
      if (row.dtua_comments != null && row.dtua_comments != '') {
        var submisionNo = JSON.parse(row.dtua_comments);
        commentCount = submisionNo.length;
      }
      return `${commentCount}`;
        }
    },
    {
      "mRender": function (data, type, row) {
        let marknew = '-';
        if (row.mark != null && row.mark != '') {
          marknew = row.mark;
        }
        return `${marknew}`;
      }
    },
    {
      "mRender": function (data, type, row) {
        //return `${row.dtua_grade}`;
        let marknew = '-';
        if (row.dtua_grade != null && row.dtua_grade != '') {
          marknew = row.dtua_grade;
        }
        return `${marknew}`;
      }
    },
        ],
        "language": {
          "emptyTable": innernoMsg
        },
        "drawCallback": function( settings ) {
    },
});
}
  componentDidUpdate(prevProps) {
 
   // this.leanerAssingmentreportrender();
   /*  if ((this.props.queryFilter.selectedCourse !== prevProps.filters.selectedCourse) || (this.props.queryFilter.startdate !== prevProps.filters.startdate) || (this.props.queryFilter.searchkey !== prevProps.queryFilter.searchkey) || (this.props.queryFilter.comstartdate !== prevProps.queryFilter.comstartdate)) {
      $('#myTable').DataTable().destroy();
      this.overallreportrender();
    } else {
      if (JSON.stringify(this.props.filters.contentDisplay) !== JSON.stringify(prevProps.filters.contentDisplay)) {
        this.contentColumnDisplay();
      }
    }*/
  }
 
componentWillUnmount(){

  $('#table_id1').DataTable().destroy();
  $('#myTable').DataTable().destroy();
  $('.data-table-wrapper')
  .find('table')
  .DataTable()
  .destroy(true); 
}
  render(){
return (<div>
  <table className="display" width="100%" id="table_id1" ref = "main1">
<thead>
                  <tr>
                    <th className="no-sort">Assignment Name</th>
                    <th className="no-sort">Status</th>
                    <th className="no-sort">Time Remaining</th>
                    <th className="no-sort">Completion Date</th>
                    <th className="no-sort">Feedback</th>
                    <th className="no-sort">No. of Submissions </th>
                    <th className="no-sort">Marks</th>
                    <th className="no-sort">Grade</th>
                  </tr>
                </thead>                 
  </table>
  </div>)
  }
}
